<template>
  <div class="form__shortfields" :style="{'align-items': align}">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    align: {type: String, default: ''}
  }
}
</script>

<style lang="sass">
.form .step .form__shortfields
  display: flex
  flex-wrap: wrap
  justify-content: space-between

  >*
    width: calc(50% - 48px)
  @include from(breakpoints.$mob)
    display: block
    >*:not(.formlabel)
      width: 100% !important
    .formlabel
      width: calc(100% - var(--labelspace))
      &:not(:first-child)
        padding-top: var(--basespace)
</style>